import { GetServerSideProps, NextPage } from 'next';
import { getDataHooksProps } from 'next-data-hooks';
import React from 'react';

import { resolveLanguageAndRedirect } from '../utils/_helper/resolve-language-and-redirect-helper';
import { setHeaders } from '../utils/_helper/set-headers';
import { TypoPage } from '../views/typo-page/typo-page';

const TypoNextPage: NextPage = () => (
    <TypoPage />
);

export default TypoNextPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
    setHeaders(context);

    const redirect = await resolveLanguageAndRedirect(context);

    if (redirect) return { redirect };

    const dataHooksProps = await getDataHooksProps({
        context,
        dataHooks: TypoPage.dataHooks
    });

    if (dataHooksProps.nextDataHooks) {
        if (!dataHooksProps.nextDataHooks['TypoContent']) {
            dataHooksProps.nextDataHooks['TypoContent'] = null;
        }

        const typoContent = dataHooksProps.nextDataHooks['TypoContent'];
        if (typoContent === 404) {
            return {
                notFound: true
            };
        }

        if (typoContent &&
            typoContent.type === 'redirect' &&
            typoContent.slug) {
            const params = typoContent.response ? typoContent.response.join(';') : '';
            return {
                redirect: {
                    destination: `${typoContent.slug}${params ? '?resp='+encodeURI(params) : ''}`,
                    permanent: false,
                },
            };
        }

        return {
            props: { ...dataHooksProps }
        };
    } else {
        return {
            notFound: true
        };
    }
};
